import { Building2, CheckCircle2, LoaderCircle, LockKeyhole, Mail, ShieldCheck } from 'lucide-react'
import { useState, type FormEvent } from 'react'
import { Navigate } from 'react-router-dom'
import { BRAND } from '../config/brand'
import { useAuthStore } from '../store/auth'

export function LoginPage() {
  const user = useAuthStore((state) => state.user)
  const login = useAuthStore((state) => state.login)
  const [username, setUsername] = useState('admin')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  if (user) return <Navigate to="/" replace />

  async function submit(event: FormEvent) {
    event.preventDefault()
    setLoading(true)
    setError('')
    try {
      await login(username, password)
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : '登录失败')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="login-page">
      <section className="login-story">
        <div className="login-brand"><Building2 size={25} /><span>{BRAND.shortName} · 企业邮箱</span></div>
        <div className="login-story-copy">
          <p className="eyebrow light">BLUEWHALE MAIL</p>
          <h1>企业邮箱，<br />管理可以更简单。</h1>
          <p>统一管理员工邮箱、群邮箱和公共邮箱，底层由 Mox 安全邮件引擎提供可靠收发能力。</p>
          <ul>
            <li><CheckCircle2 size={19} />员工邮箱一站式开通与停用</li>
            <li><CheckCircle2 size={19} />群组分发与公共地址代发</li>
            <li><CheckCircle2 size={19} />全部操作都有记录可追溯</li>
          </ul>
        </div>
        <div className="login-story-footer">
          <div className="login-security"><ShieldCheck size={19} /><span>管理操作通过独立安全通道连接 Mox</span></div>
          <div className="company-identity company-identity-dark">
            <strong>{BRAND.companyNameZh}</strong>
            <span>{BRAND.companyNameEn}</span>
          </div>
        </div>
      </section>
      <section className="login-panel">
        <form className="login-card" onSubmit={submit}>
          <div className="login-icon"><Mail size={25} /></div>
          <p className="eyebrow">管理员登录</p>
          <h2>欢迎回来</h2>
          <p className="muted">登录企业邮箱管理中心</p>
          {error && <div className="form-error" role="alert">{error}</div>}
          <label className="field">
            <span>管理员账号</span>
            <div className="input-with-icon"><Building2 size={18} /><input value={username} onChange={(e) => setUsername(e.target.value)} autoComplete="username" required /></div>
          </label>
          <label className="field">
            <span>登录密码</span>
            <div className="input-with-icon"><LockKeyhole size={18} /><input type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" required autoFocus /></div>
          </label>
          <button className="button primary wide" disabled={loading}>
            {loading ? <><LoaderCircle className="spin" size={18} />正在验证</> : '进入管理中心'}
          </button>
          <p className="login-footnote">仅授权管理员可以访问</p>
          <div className="company-identity company-identity-card">
            <strong>{BRAND.companyNameZh}</strong>
            <span>{BRAND.companyNameEn}</span>
          </div>
        </form>
      </section>
    </div>
  )
}
